import React from 'react';

export default function CloseIcon(props: any) {
  return (
    <svg
      className={props.className}
      height="15"
      viewBox="0 0 15 15"
      width="15"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#FFF"
        d="M6.725 3.57L3.822.659 3.696.542C2.765-.22 1.466-.159.65.66L.542.777l-.12.159c-.64.916-.544 2.127.23 2.902L3.553 6.75.651 9.662l-.115.126c-.762.934-.7 2.236.115 3.053l.119.11.158.12c.914.642 2.12.546 2.894-.23L6.725 9.93l2.903 2.912.127.117c.93.763 2.229.701 3.044-.117l.11-.118.12-.159c.639-.916.543-2.127-.23-2.902L9.895 6.75 12.8 3.838l.116-.126c.761-.934.7-2.236-.116-3.053l-.118-.11-.04-.035c-.889-.735-2.194-.677-3.013.145l-2.903 2.91z"
        transform="translate(.449 .125)"
      />
      <path
        fill="#171C34"
        d="M6.725 3.57L3.822.659 3.696.542C2.765-.22 1.466-.159.65.66L.542.777l-.12.159c-.64.916-.544 2.127.23 2.902L3.553 6.75.651 9.662l-.115.126c-.762.934-.7 2.236.115 3.053l.119.11.158.12c.914.642 2.12.546 2.894-.23L6.725 9.93l2.903 2.912.127.117c.93.763 2.229.701 3.044-.117l.11-.118.12-.159c.639-.916.543-2.127-.23-2.902L9.895 6.75 12.8 3.838l.116-.126c.761-.934.7-2.236-.116-3.053l-.118-.11-.04-.035c-.889-.735-2.194-.677-3.013.145l-2.903 2.91zm5.2-2.189l.08.073c.411.411.437 1.062.078 1.504l-.077.085L8.309 6.75l3.697 3.707c.412.413.436 1.068.073 1.509l-.073.08c-.41.411-1.06.437-1.5.077l-.084-.077-3.697-3.707-3.696 3.707c-.412.413-1.064.437-1.504.073l-.08-.073c-.41-.411-.436-1.062-.077-1.503l.077-.086L5.14 6.75 1.445 3.043c-.412-.413-.436-1.067-.073-1.509l.073-.08c.41-.411 1.059-.437 1.499-.077l.085.077 3.696 3.707 3.697-3.707c.411-.413 1.064-.437 1.504-.073z"
        transform="translate(.449 .125)"
      />
    </svg>
  );
}
